'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './combi-banner.component';
import dynamic from 'next/dynamic';

const DynamicCombiBannerComponent: ComponentType<Props> = dynamic(
  () => import('./combi-banner.component')
);

export default DynamicCombiBannerComponent;

export function calculateCombiBannerPlaceholderConfig(props: Readonly<Props>): PlaceholderConfig {
  const banners: number = props.banners.length;
  const heightSinceWidth = [{ sinceWidth: 0, height: props.mobileSlider ? 298 : 280 * banners }];

  switch (banners) {
    case 2:
      heightSinceWidth.push({ sinceWidth: 768, height: 378 });
      break;
    case 3:
      heightSinceWidth.push({ sinceWidth: 768, height: 275 }, { sinceWidth: 1024, height: 330 });
      break;
    case 4:
      heightSinceWidth.push({ sinceWidth: 768, height: 656 }, { sinceWidth: 1024, height: 266 });
      break;
    case 5:
      heightSinceWidth.push({ sinceWidth: 768, height: 1000 }, { sinceWidth: 1024, height: 742 });
      break;
  }

  return {
    heightSinceWidth
  };
}
